import WyjazdyMinione from "konto/Wyjazdy/Minione/WyjazdyMinione"

export default WyjazdyMinione
